import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { addErrorToast } from '@taxfix/scouts-ui'

import config from '@/config'
import { ERROR_MESSAGE_AUTHENTICATION, PATH_COMPANY_RETURN_RESET } from '@/constants'
import { getUnregisteredUserToken } from '@/helpers/unregistered-user'
import history from '@/history'

import { apiSlice } from '../api-slice'
import { store } from '../store'

const fetchBase = fetchBaseQuery({
    baseUrl: config.apiUrl,
    prepareHeaders: async (headers) => {
        const token = getUnregisteredUserToken()

        if (token) {
            headers.set('Authorization', `Bearer ${token}`)
        }

        return headers
    },
})

export const unregisteredUserBaseQuery: typeof fetchBase = async (...params) => {
    const response = await fetchBase(...params)

    const [args] = params
    if (typeof args === 'string') return response

    if (args.method?.toUpperCase() === 'GET') return response

    if (response.error?.status === 401) {
        addErrorToast({ body: ERROR_MESSAGE_AUTHENTICATION })

        store.dispatch(apiSlice.util.resetApiState())

        history.push(PATH_COMPANY_RETURN_RESET)
    }

    return response
}
